module.exports = __webpack_public_path__ + "/content/shared/img/mercedes-benz/logo.jpg";